import { Box, Stack, Typography } from '@mui/material';

export type SortKey = 'popularity' | 'priceAsc' | 'priceDesc' | 'ratingDesc' | 'bestValue';

const TABS: Array<{ key: SortKey; label: string }> = [
  { key: 'popularity', label: 'Popularity' },
  { key: 'priceAsc',   label: 'Price (Low to High)' },
  { key: 'priceDesc',  label: 'Price (High to Low)' },
  { key: 'ratingDesc', label: 'User Rating (Highest)' },
  { key: 'bestValue',  label: 'Lowest Price & Best Rated' },
];

interface ListingSortTabsProps {
  value: SortKey;
  onChange: (key: SortKey) => void;
}

export function ListingSortTabs({ value, onChange }: ListingSortTabsProps) {
  return (
    <Stack
      direction="row"
      sx={{
        bgcolor: '#fff',
        border: 1,
        borderColor: 'divider',
        borderRadius: 2,
        overflow: 'auto',
        '&::-webkit-scrollbar': { display: 'none' },
      }}
    >
      {TABS.map((tab) => {
        const active = value === tab.key;
        return (
          <Box
            key={tab.key}
            onClick={() => onChange(tab.key)}
            sx={{
              flex: 1,
              px: 2,
              py: 1.5,
              textAlign: 'center',
              cursor: 'pointer',
              borderBottom: 3,
              borderColor: active ? 'primary.main' : 'transparent',
              transition: 'all 0.15s ease',
              minWidth: { xs: 140, md: 'auto' },
              whiteSpace: 'nowrap',
              '&:hover': { bgcolor: 'background.subtle' },
            }}
          >
            <Typography
              variant="body2"
              sx={{
                fontWeight: active ? 700 : 500,
                color: active ? 'primary.main' : 'text.secondary',
              }}
            >
              {tab.label}
            </Typography>
          </Box>
        );
      })}
    </Stack>
  );
}
